
import { apiFetcher } from '@/api/api'
import { usePreInfo } from '@/api/request'
import { useMemo } from 'react'
import useSWRMutation from 'swr/mutation'

//验证图形验证码
export function useValidateGeeCheck() {
    const params = {
        path: '/site/api/v1/user/member/validateGeeCheck',
        type: 'post',
        needToken: false
    }
    return useSWRMutation(params, (params, arg: { arg: any }) => {
        return apiFetcher<any>(params, { ...arg })
    })
}

export function useApiLogin() {
    const params = {
        path: '/site/api/v1/user/login',
        type: 'post',
        needToken: false
    }
    return useSWRMutation(params, (params, arg: { arg: any }) => {
        return apiFetcher<any>(params, { ...arg })
    })
}

// 发送急速登录短信验证码
export function useSendCodeTwo() {
    const params = {
        path: '/site/api/v1/user/sendCode/two',
        type: 'post',
        needToken: false
    }
    return useSWRMutation(params, (params, arg: { arg: any }) => {
        return apiFetcher<any>(params, { ...arg })
    })
}

export function useApiRegister() {
    const { data } = usePreInfo()

    const headerString: string = useMemo(() => {
        const timestamp = Date.now()
        return JSON.stringify({
            tt: timestamp,
            xx: data?.ip
        })
    }, [data])
    const params = {
        path: '/site/api/v1/user/register',
        type: 'post',
        needToken: false,
        customHeaders: {
            'x-api-hack-xxxxx': ut.aesEncrypt(
                headerString,
                'string',
                process.env.REACT_APP_SECRET_KEY_HACK,
                process.env.REACT_APP_SECRET_IV_HACK
            )
        }
    }
    return useSWRMutation(params, (params, arg: { arg: any }) => {
        return apiFetcher<any>(params, { ...arg })
    })
}

/**
 * 忘记密码第一步，手机号身份认证
 */
export function useSendForgetCode() {
    const params = {
        path: '/site/api/v1/user/forgetByPhone/one',
        type: 'post'
    }
    const result = useSWRMutation(params, (params, arg: { arg: any }) => {
        return apiFetcher<any>(params, { ...arg })
    })

    return result
}


/**
 * 忘记密码验证 手机号
 */
export function useForgetByPhoneTwo() {
    const params = {
        path: '/site/api/v1/user/forgetByPhone/two',
        type: 'post'
    }
    const result = useSWRMutation(params, (params, arg: { arg: any }) => {
        return apiFetcher<any>(params, { ...arg })
    })
    return result
}


/**
 * 忘记密码第三步
 * /site/api/v1/user/forgetByEmail/three
 */
export function useForgetByThee(isEmail) {
    const params = {
        path: isEmail ? '/site/api/v1/user/forgetByEmail/three' : '/site/api/v1/user/forgetByPhone/three',
        type: 'post'
    }
    const result = useSWRMutation(params, (params, arg: { arg: any }) => {
        return apiFetcher<any>(params, { ...arg })
    })

    return result
}

/**
 * 忘记密码验证 ， 邮箱
 * /site/api/v1/user/forgetByEmail/two
 */
export function useForgetByEmailTwo() {
    const params = {
        path: '/site/api/v1/user/forgetByEmail/two',
        type: 'post'
    }
    const result = useSWRMutation(params, (params, arg: { arg: any }) => {
        return apiFetcher<any>(params, { ...arg })
    })
    return result
}